import { matchPath } from "react-router-dom";
import { routes } from "./routes";

const HOME_HEALTH_EXTERNAL_ALLOWED_ROUTE_PATTERNS = [
  routes.visitNotes.path,
  routes.newVisit.path,
  routes.visitNote.path,
  routes.visitCalendar.path,
  routes.pdfViewer.path,
  routes.compassusPatient.path,
  routes.compassusNavigator.path,
  routes.oasisPdf.path,
  routes.telehealth.path,
  routes.telehealthCall.path,
  routes.npProductivity.path,
  routes.npProductivityV2.path,
  routes.npDashboard.path,
  routes.workflowsEligibility.path,
  routes.settings.path,
  routes.changeFacility.path,
  routes.userInfo.path,
  routes.changePassword.path,
  routes.changePin.path,
  routes.feedback.path,
  routes.contactSupport.path,
  routes.rateApp.path,
  routes.privacyPolicy.path,
  routes.termsOfUse.path,
  routes.intendedUse.path,
  routes.reportAProblem.path,
  routes.faq.path,
  routes.neo.path,
  routes.neoWorkflows.path,
  routes.logout.path,
] as const;

export const isHomeHealthExternalAllowedRoute = (pathname: string): boolean =>
  HOME_HEALTH_EXTERNAL_ALLOWED_ROUTE_PATTERNS.some((path) => {
    const normalizedPathname = pathname.split(/[?#]/)[0] || "/";
    return matchPath({ path, end: true }, normalizedPathname) !== null;
  });
